import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconCopy = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M5.591 1.926c-.883.148-1.694.581-2.39 1.274a4.43 4.43 0 0 0-1.139 1.824l-.174.512v36.672l.174.513c.42 1.24 1.292 2.218 2.45 2.752.84.388.777.383 5.184.383h4.032l.337-.152c.424-.192.924-.727 1.064-1.137.132-.386.132-1.004 0-1.39-.14-.41-.64-.945-1.064-1.136l-.337-.153-3.798-.032-3.797-.032-.123-.151c-.12-.148-.122-.521-.122-17.811V6.202l.157-.157.157-.157h17.66c17.29 0 17.663.003 17.81.122l.152.123.032 3.797.032 3.798.152.337c.192.424.727.924 1.137 1.064.386.132 1.004.132 1.39 0 .41-.14.945-.64 1.136-1.064l.153-.337V9.696c0-4.407.005-4.344-.383-5.184-.534-1.158-1.512-2.03-2.752-2.45l-.513-.174-18.144-.009c-9.98-.005-18.292.016-18.473.047m16.393 16.231c-1.427.2-2.748 1.158-3.38 2.451-.54 1.104-.498-.633-.477 19.744.017 16.485.028 18.142.123 18.442.479 1.527 1.556 2.644 3.029 3.144l.513.174h36.672l.512-.174A4.45 4.45 0 0 0 60.8 60.8a4.45 4.45 0 0 0 1.138-1.824l.174-.512V21.792l-.174-.513c-.5-1.473-1.617-2.55-3.144-3.03-.3-.094-1.94-.104-18.474-.11-9.98-.005-18.23.003-18.336.018m.3 4.135-.14.148v35.358l.157.157.157.157h35.34l.157-.157.157-.157v-35.34l-.157-.157-.157-.157H22.422z" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconCopy.displayName = 'IconCopy';